import { render, staticRenderFns } from "./shopGoodsCatEdit.vue?vue&type=template&id=006d484a&"
import script from "./shopGoodsCatEdit.vue?vue&type=script&lang=js&"
export * from "./shopGoodsCatEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports